<template>
  <div>
    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="item.num && activeInfo">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10">
          <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(item1, j) in tableFields(item.moduleId)">
              <el-table-column v-if="item1.field != 'rk'" :key="j" :label="item1.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="whichType(scope.row[j])==='string'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                  <!-- <span v-else-if="whichType(scope.row[j])==='array'" v-html="arrParse(scope.row[j])"></span> -->
                  <span v-else-if="whichType(scope.row[j])==='object'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                  <span v-else-if="whichType(scope.row[j])==='img'"><img style="width:64px" :src="columnValue(repliceHttps(scope.row[j]), item.moduleId)" alt="" srcset=""></span>
                  <span v-else-if="whichType(scope.row[j])==='url'"><a :href="columnValue(scope.row[j], item.moduleId)" style="color:#409EFF" target="_blank"
                      rel="noopener noreferrer">{{scope.row[j]}}</a></span>
                  <span v-else>{{ columnValue(scope.row[j], item.moduleId) || '--' }} </span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="val => handleCurrentChange(val, i)" />
        </div>
      </title-block>
    </template>
    
  </div>
</template>

<script>
import mixin from '../mixins/enterpriseTabs'
export default {
  mixins: [mixin],
  name: 'bidding',
  data() {
    return {
      name: this.$route.query.name,
      titles: [
        { type: '', label: '招投标', num: 0, moduleId: '' },
      ],
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/ .el-table th > .cell {
  font-size: 12px;
  font-weight: 400;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}
/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}
</style>
